import { useEffect, useState } from "react";
import { listUsuariosAdmin } from "../../api/agendaApi";

// /usuarios (catalogo real de posibles doctores/id_user_doctor) solo lo
// puede consultar un usuario con rol Administrador (ver
// app/routers/usuarios_admin.py: require_admin). Este hook intenta cargarlo
// una vez; si el backend responde 403 (usuario logueado no es admin), cae a
// modo "sin catalogo" y quien use el hook debe mostrar un InputNumber para
// capturar id_user_doctor a mano en vez de romper la pantalla.
export default function useDoctorOptions() {
  const [doctores, setDoctores] = useState([]);
  const [disponible, setDisponible] = useState(true);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let activo = true;
    setCargando(true);
    listUsuariosAdmin()
      .then((items) => {
        if (!activo) return;
        setDoctores(Array.isArray(items) ? items : []);
        setDisponible(true);
      })
      .catch(() => {
        if (!activo) return;
        setDoctores([]);
        setDisponible(false);
      })
      .finally(() => {
        if (activo) setCargando(false);
      });
    return () => {
      activo = false;
    };
  }, []);

  return { doctores, disponible, cargando };
}
